import { type JSX, useState } from 'react';

import { Image } from '@change/ds-core-ui';

const ZOOM_IN_ICON = 'https://static.change.org/images/zoom-in-icon.svg?v3';
const ZOOM_OUT_ICON = 'https://static.change.org/images/zoom-out-icon.svg?v3';

export function ZoomButton({ onClick }: { onClick: () => void }): JSX.Element {
	const [isZoomedIn, setIsZoomedIn] = useState(false);

	return (
		<Image
			src={isZoomedIn ? ZOOM_IN_ICON : ZOOM_OUT_ICON}
			role="button"
			tabIndex={0}
			data-qa="pre-made-post-modal-zoom-button"
			alt={isZoomedIn ? 'Zoom out' : 'Zoom in'}
			className="absolute top-4 right-4 h-[44px] w-[44px] bg-transparent"
			onClick={() => {
				setIsZoomedIn((prevValue) => !prevValue);
				onClick();
			}}
		/>
	);
}
